module Meevo.Plugins.PaymentType {
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.PaymentType> {
        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        public missingField: any = -1;

        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint).then(data => {
                this.model = data;
            });
        }

        beforeSetFocusOnField() {
            setTimeout(() => this.setFocusOnField(this.missingField), 400);
        }

        setFocusOnField(field: any) {
            switch (field) {
                default:
                    $('#displayName input').focus();
                    break;
            }
        }

        isAllowedRefundableOverride() {
            return this.model && (this.model.allowIsRefundableOverride == null || this.model.allowIsRefundableOverride);
        }
    }
}
